// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DOO9A","colMin":"styles_colMin__1jTob"};